import { render } from "./profiletab.vue?vue&type=template&id=c96d2442&scoped=true"
import script from "./profiletab.vue?vue&type=script&lang=js"
export * from "./profiletab.vue?vue&type=script&lang=js"

import "./profiletab.vue?vue&type=style&index=0&id=c96d2442&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96d2442"]])

export default __exports__